export default __webpack_public_path__ + "static/media/coming-soon.edb6c6b6.png";